import { render, staticRenderFns } from "./ComposeEdit.vue?vue&type=template&id=3b58b1e6&scoped=true&"
import script from "./ComposeEdit.vue?vue&type=script&lang=js&"
export * from "./ComposeEdit.vue?vue&type=script&lang=js&"
import style0 from "./ComposeEdit.vue?vue&type=style&index=0&id=3b58b1e6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b58b1e6",
  null
  
)

export default component.exports